/**
 * @generated SignedSource<<57f14892affafb4bae1aa990d92b3439>>
 * @relayHash 87b7d3773855b6ce34cca562fd95a7e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f694472e79669ae176ab3ca692821e8ab421a84925789f9cb2aa4296f3343a0e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AvailabilityPageQuery } from './AvailabilityPageQuery.graphql';

const node: PreloadableConcreteRequest<AvailabilityPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f694472e79669ae176ab3ca692821e8ab421a84925789f9cb2aa4296f3343a0e",
    "metadata": {},
    "name": "AvailabilityPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
